module.exports = __webpack_public_path__ + "static/media/ic-row-delete.a2e349db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table-icons/ic-row-delete.svg
// module id = 824
// module chunks = 17